var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPdfArrowRightPage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.44002 3.99987L16.73 11.2899C16.8237 11.3828 16.8981 11.4934 16.9489 11.6153C16.9997 11.7372 17.0258 11.8679 17.0258 11.9999C17.0258 12.1319 16.9997 12.2626 16.9489 12.3845C16.8981 12.5063 16.8237 12.6169 16.73 12.7099L9.37002 20.0699C9.27706 20.1636 9.16646 20.238 9.0446 20.2888C8.92274 20.3395 8.79203 20.3657 8.66002 20.3657C8.52801 20.3657 8.3973 20.3395 8.27544 20.2888C8.15358 20.238 8.04298 20.1636 7.95002 20.0699H8.00002C7.81377 19.8825 7.70923 19.6291 7.70923 19.3649C7.70923 19.1007 7.81377 18.8472 8.00002 18.6599L14.61 11.9999L8.00002 5.40987C7.81377 5.22251 7.70923 4.96906 7.70923 4.70487C7.70923 4.44069 7.81377 4.18724 8.00002 3.99987C8.0933 3.90309 8.20514 3.82611 8.32885 3.77353C8.45256 3.72095 8.5856 3.69385 8.72002 3.69385C8.85444 3.69385 8.98748 3.72095 9.11119 3.77353C9.2349 3.82611 9.34674 3.90309 9.44002 3.99987Z",
    fill: "#767B88"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfArrowRightPage);
export default __webpack_public_path__ + "static/media/pdf_arrow_right_page.257d8ec0024ffd7e2cfb2ad024da98d4.svg";
export { ForwardRef as ReactComponent };